<template>

<app-input-wrapper :slim="slim" :value="value" :note="note" :label="label" :errored="errored">

	<input type="text" :value="value" :maxlength="maxlength" :placeholder="placeholder" v-on:input="onValueChange($event.target.value)" v-if="!multiline" />

    <textarea :value="value" :placeholder="placeholder" v-on:input="onValueChange($event.target.value)" v-if="multiline" />

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

    mixins: [mixinInput],
    
    props: ['multiline', 'maxlength']

}

</script>

<style scoped>

.input textarea,
.input input {
	border: 1px solid var(--color-grey-light);
	height: 40px;
	border-radius: 4px;
	transition: all 100ms linear;
	width: 100%;
	font-size: 14px;
	color: var(--color-grey-dark);
	padding: 0px 10px;
}

.input textarea {
    height: 94px;
    padding: 10px;
    line-height: 18px;
    resize: none;
}

.input.is-errored input,
.input.is-errored textarea {
	border-color: var(--color-red-light);
}

.is-desktop .input:hover input,
.is-desktop .input:hover textarea {
	border-color: var(--color-grey-highlight);
}

.is-desktop .input.is-errored:hover input,
.is-desktop .input.is-errored:hover textarea {
	border-color: var(--color-red-light);
}

.input input::placeholder,
.input textarea::placeholder {
	color: var(--color-grey);
}

</style>